export default __webpack_public_path__ + "static/media/plunger.abe7efa2.mp3";